// extracted by mini-css-extract-plugin
module.exports = {"SubTopicColumnItem":"SubTopicColumn_SubTopicColumnItem__1JkSd"};